module.exports = __webpack_public_path__ + "static/media/golf-carousel-1280x800.ca00aba8.jpg";